import { useState, FormEvent } from "react";
import { GradientButton } from "../Button";

interface DomainSearchProps {
  onSearch?: (value: string) => void;
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
}

export default function DomainSearch({ 
  onSearch, 
  value: controlledValue,
  onChange,
  placeholder = "Search your domain name here..."
}: DomainSearchProps) {
  const [internalQuery, setInternalQuery] = useState<string>("");
  
  // Use controlled value if provided, otherwise use internal state
  const query = controlledValue !== undefined ? controlledValue : internalQuery;
  const setQuery = (newValue: string) => {
    if (controlledValue === undefined) {
      setInternalQuery(newValue);
    }
    if (onChange) {
      onChange(newValue);
    }
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (onSearch && query.trim()) {
      onSearch(query);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setQuery(newValue);
  };

  return (
    <form onSubmit={handleSubmit} className="relative w-full">
      <div className="flex gap-3 relative">
        <input
          type="text"
          value={query}
          onChange={handleChange}
          placeholder={placeholder}
          className="flex-1 px-4 md:px-8 py-5 bg-white border border-border/50 rounded-full text-black placeholder:text-black-700 focus:outline-none focus:ring-2 focus:ring-primary"
        />

        {/* Button overlay */}
        <div className="absolute right-[5px] top-[5px]">
          <GradientButton
            type="submit"
            className="rounded-full px-6 md:px-8 bg-primary hover:bg-primary/90"
          >
            Search
          </GradientButton>
        </div>
      </div>
    </form>
  );
}